import { lazy } from 'react';

export const AcceptPrivacyPolicyPage = lazy(() => import('./AcceptPrivacyPolicyPage/AcceptPrivacyPolicyPage'));
